import posNotificationInstance from '../instance'

const updateNotificationStatus = (id, status) => {
	return posNotificationInstance.put(`notifications/${id}`, { status })
}

export default updateNotificationStatus